<template>
  <div>
      <div class="mycontainer" v-if="tempId">
            <!--<div class="topcontent displayflex-row" ref="tabitem">-->
              <!--<el-tabs style="width: 100%;">-->
                <!--<el-tab-pane-->
                  <!--v-for="(item,index) in tabList"-->
                  <!--:key="item.tabName"-->
                <!--&gt;-->
              <!--<div-->
                   <!--slot="label"-->
                   <!--class="toptitle textline1"-->
                   <!--:class="{toptitleactive:activeIndex==index}"-->
                   <!--@click="handleClick(item,index,$event)">{{item.tabName}}</div>-->
                <!--</el-tab-pane>-->
              <!--</el-tabs>-->
            <!--</div>-->
        <div class="tabnameclass">数据信息</div>
        <div class="displayflex-row" style="align-items: start;">

          <div class="leftcontent">
            <div
              style="position: relative;"
              v-for="(item,index) in tabList"
              :key="item.tabName"
            >
              <div
                class="toptitle textline1"
                :class="{toptitleactive:activeIndex==index}"
                @click="handleClick(item,index,$event)">{{Number(index+1)}}、{{item.tabName}}</div>
              <i class="iconfont icon-tick" v-if="item.flag==1"></i>
            </div>
          </div>

          <div class="tabcontentclass" v-loading="isloading">
            <!--<div v-for="(item,index) in tabList" :key="item.tabId+index">-->
              <keep-alive>
                <div v-if="tabList&&tabList.length>0&&tabList[activeIndex].titleList&&tabList[activeIndex].titleList.length>0">
                  <div class="tabnameclass">{{tabList[activeIndex].tabName}}</div>

                  <div class="tabcontent-itemclass" v-for="(item1,index1) in tabList[activeIndex].titleList" :key="tabList[activeIndex].tabId+item1.titleId+index1">
                    <div class="addproject" v-if="item1.add=='1'&&submitstatus!='1'" @click="addProject(activeIndex,index1,'')">添加项目</div>

                    <div class="resetproject" v-if="item1.add=='1'&&submitstatus!='1'" @click="resetProject(activeIndex,index1,item1.titleId)">
                      <img style="margin-right: 6px;width: 18px;height: 18px" :src="resetimg"/>
                      <span>重置</span>
                    </div>
                    <div class="deleteproject" v-if="item1.add=='1'&&submitstatus!='1'" @click="deleteProject(activeIndex,index1,item1.titleId)">
                      <img style="margin-right: 6px;width: 18px;height: 18px" :src="deleteimg"/>
                      <span>删除</span>
                    </div>

                    <div class="typeclass">{{titleNameChange(item1)}}</div>

                    <div class="tabcontent-contentclass">
                      <template v-for="(item2,index2) in item1.colList">
                        <div class="displayflex-row elinput-itemlist">
                          <div class="nameclass textline2"><span style="color: #ff4d51;font-size: 18px;" v-if="item2.colRequired=='1'">*</span>{{item2.colName}}:</div>
                          <!--
                          输入框：ElInput，
                          多选：ElSelectGroup
                          单选：ElRadio
                          单选下拉框：ElSelect
                          时间选择器：ElDate
                          多行文本输入框：Eltextarea
                          纯文本：Eltext
                          地区：ElRegion
                          输入框支持模糊搜索：ElAutocomplete
                          -->
                          <template v-if="item2.colInsertType=='INT'">
                            <el-input
                              :disabled="submitstatus!='1'?false:true"
                              :placeholder="item2.contentLimit"
                              @input="item2.colValue = item2.colValue.replace(/[^\d]/g,'')"
                              v-model="item2.colValue"
                              :maxlength="Number(item2.lenthLimit)"
                              v-if="item2.colType=='ElInput'"
                              :id="item1.titleId+item2.colId"></el-input>
                          </template>
                          <template v-if="item2.colInsertType=='TEXT'">
                            <el-input
                              :disabled="submitstatus!='1'?false:true"
                              :placeholder="item2.contentLimit"
                              v-model="item2.colValue"
                              :maxlength="Number(item2.lenthLimit)"
                              v-if="item2.colType=='ElInput'"
                              :id="item1.titleId+item2.colId"></el-input>
                          </template>
                          <template v-if="item2.colInsertType=='DOUBLE'">
                            <el-input
                              :disabled="submitstatus!='1'?false:true"
                              :placeholder="item2.contentLimit"
                              @keyup.native="proving(activeIndex,index1,index2)"
                              v-model="item2.colValue"
                              :maxlength="Number(item2.lenthLimit)"
                              v-if="item2.colType=='ElInput'"
                              :id="item1.titleId+item2.colId"></el-input>
                          </template>
                          <template v-if="item2.colType=='Eltextarea'">
                            <el-input
                              :disabled="submitstatus!='1'?false:true"
                              :placeholder="item2.contentLimit"
                              v-model="item2.colValue"
                              type="textarea"
                              :id="item1.titleId+item2.colId"
                              :maxlength="Number(item2.lenthLimit)"
                              show-word-limit></el-input>
                          </template>

                          <template v-if="item2.colType=='ElAutocomplete'">
                            <el-autocomplete
                              :disabled="submitstatus!='1'?false:true"
                              v-model="item2.colValue"
                              :fetch-suggestions="querySearchAsync"
                              :placeholder="item2.contentLimit"
                              @select="handleSelect($event,item1)"
                            >
                                <div slot-scope="{ item }">
                                  <span v-html="item.nameStr"></span>
                                </div>

                            </el-autocomplete>
                          </template>

                          <div style="font-size: 10px;color: #ed1d3b;" v-if="(item2.colType=='Eltextarea'||item2.colType=='ElInput')&&item2.colValue&&(item2.colValue.length>=Number(item2.lenthLimit))">*已达到最大限制！</div>
                          <el-radio-group v-model="item2.colValue" v-if="item2.colType=='ElRadio'">
                             <el-radio
                               :disabled="submitstatus!='1'?false:true"
                               :label="item3"
                               v-for="(item3,index3) in item2.contentLimit"
                               :key="item2.colId+item3">{{item3}}</el-radio>
                          </el-radio-group>

                          <el-select
                            v-model="item2.colValue"
                            :disabled="submitstatus!='1'?false:true"
                            placeholder="请选择"
                            v-if="item2.colType=='ElSelect'">
                            <el-option
                              v-for="(item3,index3) in item2.contentLimit"
                              :key="item2.colId+item3"
                              :label="item3"
                              :value="item3">
                            </el-option>
                          </el-select>

                          <el-date-picker
                            :disabled="submitstatus!='1'?false:true"
                            v-model="item2.colValue"
                            v-if="item2.colType=='ElDate'"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>

                          <!--多选  10个以内  -->
                          <template v-if="item2.colType=='ElSelectGroup'&&item2.contentLimit&&item2.contentLimit.length<=10" >
                            <el-checkbox-group v-model="item2.colValue">
                              <el-checkbox
                                :disabled="submitstatus!='1'?false:true"
                                :label="item3"
                                v-for="(item3,index3) in item2.contentLimit"
                                :key="item2.colId+item3"></el-checkbox>
                            </el-checkbox-group>
                          </template>

                          <!--多选  10个以上  -->
                          <el-select
                            :disabled="submitstatus!='1'?false:true"
                            v-if="item2.colType=='ElSelectGroup'&&item2.contentLimit&&item2.contentLimit.length>10"
                            v-model="item2.colValue"
                            multiple
                            collapse-tags
                            placeholder="请选择">
                            <el-option
                              v-for="(item3,index3) in item2.contentLimit"
                              :key="item2.colId+item3"
                              :label="item3"
                              :value="item3">
                            </el-option>
                          </el-select>

                          <div v-if="item2.colType=='Eltext'">{{item2.contentLimit}}</div>

                          <template v-if="item2.colType=='ElRegion'">
                            <!--国家-->
                            <el-select clearable
                                       :disabled="submitstatus!='1'?false:true"
                                       v-model="item2.colValue[0]"  filterable placeholder="请选择" @change="countrychange($event,item2.colValue)" style="margin-right: 15px;">
                              <el-option
                                v-for="(item,index) in countriesList"
                                :key="item.CountryID"
                                :label="item.CountryName"
                                :value="item.CountryName+'y'+index">
                              </el-option>
                            </el-select>

                            <!--省/州-->
                            <el-select clearable
                                       :disabled="submitstatus!='1'?false:true"
                                       v-model="item2.colValue[1]" filterable placeholder="请选择" @change="statechange($event,item2.colValue)" style="margin-right: 15px;">
                              <el-option
                                v-for="(item,index) in statesList"
                                :key="item.StationID"
                                :label="item.StationName"
                                :value="item.StationName+'y'+index">
                              </el-option>
                            </el-select>

                            <!--市-->
                            <el-select clearable
                                       :disabled="submitstatus!='1'?false:true"
                                       v-model="item2.colValue[2]" filterable placeholder="请选择">
                              <el-option
                                v-for="item in citiesList"
                                :key="item.CityID"
                                :label="item.CityName"
                                :value="item.CityName">
                              </el-option>
                            </el-select>
                          </template>

                        </div>
                      </template>

                    </div>
                  </div>

                  <div style="margin:40px 0 80px 200px;" v-if="submitstatus!='1'">
                    <button class="submitclass" @click="submit(tabList[activeIndex])" style="margin-bottom: 20px;">保存</button>
                    <button class="cancleclass" @click="insertDataList" v-if="formId">返回列表</button>
                  </div>
                </div>
              </keep-alive>
            <!--</div>-->
          </div>

        </div>

      </div>
  </div>
</template>

<script>
  import ElTabs from "element-ui/packages/tabs/src/tabs";
  import datalist1 from "../datalist.json"
  import * as api from "../../utils/api"
  import axios from "axios";
  import ElInput from "element-ui/packages/input/src/input";
  import HeaderCommon from '../../components/HeaderCommon'
  import LeftNav from '../../components/LeftNav'
  import deleteimg from '../../assets/img/delete.png'
  import resetimg from  '../../assets/img/reset.png'
  import ElStep from "element-ui/packages/steps/src/step";

  import area from "../../assets/json/area.json"

  export default {
    components: {
      ElStep,
      ElInput,
      ElTabs,
      HeaderCommon,
      LeftNav,
    },
    name: "data-collection",
    data(){
      return{
        submitstatus:'1',//1 说明已提交  0 未提交  1已提交  2 退回
        deleteimg,resetimg,
        areaList:['','',''],
        activeName:'',
        activeIndex:0,
        radio:'0',
        tabList:[],
        form:[],
        tempId:this.$store.state.temId?this.$store.state.temId:'',//模板id
        list:[],
        isloading:false,
        formId:this.$route.query.formId?this.$route.query.formId:'',
        countriesList:area,//国家
        statesList:[],
        citiesList:[],
        //20210301200523
      }
    },
    mounted(){
      // console.log('menulist',this.$store.state.menuList)
      // for(var i=0; i<this.$store.state.menuList.length;i++){
      //   var item = this.$store.state.menuList[i].menuList;
      //   for(var j =0;j<item.length;j++){
      //     if(this.$route.name==item[j].collection){
      //       this.$store.commit('SET_temId', item[j].temId);
      //       this.tempId=this.$store.state.temId;
      //
      //       console.log('000000',this.$store.state.temId)
      //
      //       // return item[j].permissionId;
      //     }
      //   }
      //
      // }
      //
      // console.log('1111',this.$store.state.temId)

      if(this.formId){
        this.getFormDetail();
      }else{
        this.getFormTemp();
      }
    },
    watch:{
      // activeName(oldval,newval){
      //   console.log(oldval,newval)
      // }
    },
    methods:{
      //国家改变
      countrychange(countrylist,colValue){
        // console.log(countrylist,colValue)
        colValue.splice(1,2,'')
        if(countrylist) {
          var countryindex = countrylist.split('y')[1];
          if(this.countriesList[countryindex].Station&&this.countriesList[countryindex].Station.length>0) {
            this.statesList=this.countriesList[countryindex].Station;
          }else{
            this.statesList=[];
          }
        }else{
          this.statesList=[];
        }
        this.citiesList=[];
      },

      //省或者州
      statechange(stateidlist,colValue){
        // console.log(stateidlist,colValue)
        colValue.splice(2,1,'')
        if(stateidlist){
          var stateindex=stateidlist.split('y')[1];
          if(this.statesList[stateindex].City&&this.statesList[stateindex].City.length>0){
            this.citiesList=this.statesList[stateindex].City;
          }else{
            this.citiesList=[];
          }
        }else{
          this.citiesList=[];
        }

      },
      //标题名字修改 titleName
      titleNameChange(item1){

        var titleName=item1.titleName;
        if(item1.add=='1'){
          if(item1.titleId.indexOf('yy')==-1){
            titleName=item1.titleName+'1';
            item1.titleId=item1.titleId+'yy1'
          }else{
            var titleIdArr = item1.titleId.split('yy');
            titleName=item1.titleName+titleIdArr[titleIdArr.length-1];
          }
        }
          return titleName;
      },

      //新增
      insertDataList(){
        this.$router.push({name:'datacollectionlist'})

        // this.$router.push({name:'datacollection'})
      },

      //保存
      submit(item){
        this.isloading=true;
        this.list=[];
        //每个单独分类
        for(var j =0 ;j<item.titleList.length;j++) {
            var item1 = item.titleList[j];
            for(var k =0 ;k<item1.colList.length;k++) {
              var item2 = item1.colList[k];
              var titleId =item1.titleId;
              var colValue=item2.colValue;
              if(item2.colRequired==1&&(!item2.colValue||item2.colValue==''||item2.colValue==null||item2.colValue==[])){
                this.$message.error(item2.colName+'为空！')
                this.isloading=false;
                return;
              }
              if(item2.colType=='ElSelectGroup'){
                colValue= item2.colValue.join(";");
              }
              if(item2.colType=='ElRegion'){
                var colValuechange=''
                for(var regionindex =0;regionindex<item2.colValue.length;regionindex++){

                  var regionitem=item2.colValue[regionindex];
                  console.log(regionitem,regionitem.split('y')[0])

                  colValuechange=colValuechange+regionitem.split('y')[0]+';'
                }
                colValue=colValuechange;
              }
              this.list.push({
                "colId": item2.colId,
                "colName": item2.colName,
                "colValue": colValue,
                "tabId": item.tabId,
                "tempId": this.tempId,
                "titleId": item1.titleId
              })
            }

        }

        item.flag=1;
        // console.log(this.list)
        if(this.formId){
          this.updateForm();

        }else{
          this.insertForm();

        }
      },

      handleClick(item,index) {
        if(this.submitstatus=='1'){
          this.activeIndex = index;

          return;
        }
        var self =this;
        if(index==self.activeIndex){
          return;
        }
        this.$confirm('请进行数据保存？', '提示', {
          // distinguishCancelAndClose: true,
          closeOnClickModal:false,
          confirmButtonText: '已保存',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.activeIndex = index;

          // self.submit(self.tabList[self.activeIndex])

        }).catch((rs) => {

          // if(rs == 'cancel'){
          //   self.activeIndex = index;
          //
          // }

        });

      },

      //获取模板
      getFormTemp() {
        if(!this.tempId){
          return;
        }

        var self = this;
        self.isloading= true;
        api.getFormTemp({
          tempId: this.tempId,
        })
          .then(rs => {
            // console.log(rs)
            if (rs.status == 200) {
              self.submitstatus='0';
              self.activeName = rs.data.tabList[0].tabId;
              self.tabList = rs.data.tabList;

            } else {
              self.$message.error(rs.message)

            }
            self.isloading= false;

          })
          .catch(err => {
            self.$message.error(err)
            self.isloading= false;


          })
      },

      //获取详情
      getFormDetail() {

       var self = this;
        self.isloading= true;

        api.getFormDetail({
         formId: this.formId,
      })
      .then(rs => {
        // console.log(rs)
        if (rs.status == 200) {
          if(rs.data&&rs.data.tabList&&rs.data.tabList.length>0){
            self.submitstatus=rs.data.submit;
            self.activeName = rs.data.tabList[0].tabId;
            self.tabList = rs.data.tabList;
          }

        } else {
          self.$message.error(rs.message)

        }
        self.isloading= false;

      })
      .catch(err => {
        self.$message.error(err)
        self.isloading= false;

      })
  },

      //提交模板
      insertForm(){
        this.isloading=true;

        var self = this;
        api.insertForm({
          id:this.formId,
          list:this.list
        }
      )
          .then(rs => {
            self.isloading=false;

            if (rs.status == 200) {

              self.formId = rs.data;
              self.$message({
                message: '保存成功！',
                type: 'success'
              });

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.isloading=false;
            self.$message.error(err)

          })
      },

      //修改更新模板
      updateForm(){
        // this.isloading=true;

        var self = this;
        api.updateForm({
          id:this.formId,
          list:this.list
          })
          .then(rs => {
            self.isloading=false;
            if (rs.status == 200) {
              self.$message({
                message: '提交成功！',
                type: 'success'
              });

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.isloading=false;
            self.$message.error(err);
          })
      },

      //新增项目信息 tabindex,titleindex
      addProject(index,index1,type){
        var colList=[];//组件列表
        var titleId=this.tabList[index].titleList[index1].titleId; //当前的titleId
        var insertIndex=0;//插入数组中的位置

        //没有找到yy
        if(titleId.indexOf('yy')!=-1){

          var titleIdArr = titleId.split('yy');
          titleId=titleIdArr[0];
        }
        var inserttitleId=titleId;

        //插入第几条
        for(var i = index1 ;i<this.tabList[index].titleList.length;i++){
          var insertItem=this.tabList[index].titleList[i];
          if(this.tabList[index].titleList[i].titleId.indexOf(inserttitleId)==-1){

            //之前存在插入信息  累计加1
              var titleIdArr = this.tabList[index].titleList[i-1].titleId.split('yy');
              titleId=titleIdArr[0] +'yy'+ Number(Number(titleIdArr[titleIdArr.length-1])+1);
              insertIndex = i;
            break;
          }
          if(Number(i+1) == this.tabList[index].titleList.length&&this.tabList[index].titleList[i].titleId.indexOf(inserttitleId)!=-1){
            insertIndex = this.tabList[index].titleList.length;

            //之前存在插入信息  累计加1
              var titleIdArr = insertItem.titleId.split('yy');
              titleId=titleIdArr[0] +'yy'+ Number(Number(titleIdArr[titleIdArr.length-1])+1);

            break;
          }
        }
        for(var i =0 ;i<this.tabList[index].titleList[index1].colList.length;i++){

          var item =this.tabList[index].titleList[index1].colList[i];
          colList.push({
            colId: item.colId,
            colName: item.colName,
            colType: item.colType,
            colValue: item.colType=='ElSelectGroup'?[]:item.colType=='ElRegion'?['','','']:null,
            contentLimit: item.contentLimit,
            isShow: item.isShow,
            lenthLimit: item.lenthLimit,
            colRequired:item.colRequired,
            colInsertType:item.colInsertType,
          })
        }

        if(type=='reset'){
          var insertDic={
            colList:colList,
            titleId: this.tabList[index].titleList[index1].titleId,
            titleName: this.tabList[index].titleList[index1].titleName,
            add:this.tabList[index].titleList[index1].add,
          };

          // this.tabList[index].titleList.splice(Number(insertIndex - 1),1,insertDic);
          this.$set(this.tabList[index].titleList,index1,insertDic)

          this.$message({
            message: '重置成功！',
            type: 'success'
          });
        }else{
          var insertDic={
            colList:colList,
            titleId: titleId,
            titleName: this.tabList[index].titleList[index1].titleName,
            add:this.tabList[index].titleList[index1].add,

          };
          this.tabList[index].titleList.splice(insertIndex,0,insertDic);//
          // this.$message({
          //   message: '添加成功！',
          //   type: 'success'
          // });
        }
        console.log(this.tabList[index].titleList)

      },

      //删除项目
      deleteProject(index,index1,titleId){

        var titleId=titleId;
        var insertIndex=null;
        //没有找到yy
        if(titleId.indexOf('yy')==-1){
          titleId=this.tabList[index].titleList[index1].titleId+'yy'+new Date().valueOf();
        }else{
          var titleIdArr = titleId.split('yy');
          titleId=titleIdArr[0]+'yy'+new Date().valueOf();
        }
        var inserttitleId=titleId.split('yy')[0];

        for(var i = 0 ;i<this.tabList[index].titleList.length;i++){
          if(this.tabList[index].titleList[i].titleId.indexOf(inserttitleId)!=-1&&i!=index1){
            insertIndex = i;
            break;
          }
        }
        if(insertIndex==null){
          this.$message.error('不能删除模板数据！')
          return;
        }


          var self =this;
          this.$confirm('是否删除该数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.delForm(titleId,index,index1)
          }).catch(() => {

          });

      },

      //重置
      resetProject(index,index1,titleId){

          //  重置
          this.addProject(index,index1,'reset')
      },

      delForm(titleId,index,index1){

        var self = this;
        api.delForm({
          titleId:titleId,
          formId:this.formId
        })
          .then(rs=>{
            if (rs.status == 200) {
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
            }
              self.tabList[index].titleList.splice(index1,1)

          })
          .catch(err=>{
            self.$message.error(rs.message)

          })
      },

      //小数点
      proving(index,index1,index2){
        var value = this.tabList[index].titleList[index1].colList[index2].colValue;
        console.log(value)
        // this.list[index].value 是输入框输入的值，这里是列表循环出来的输入框
        // 先把非数字的都替换掉，除了数字和.
        value = value.replace(/[^\d.]/g, '');
        // 必须保证第一个为数字而不是.
        value = value.replace(/^\./g, '');
        // 保证只有出现一个.而没有多个.
        value = value.replace(/\.{2,}/g, '');
        // 保证.只出现一次，而不能出现两次以上
        value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        let count = -1
        for (let i in value) {
          if (value[i] === '.') {
            count = i
          }
          if (count !== -1) {
            if (i - count > 2) {
              value = value.substring(0, value.length - 1)
            }
          }
        }
        this.tabList[index].titleList[index1].colList[index2].colValue=value;
      },

      //高级搜索
      querySearchAsync(queryString, cb) {
        // console.log(queryString)
        // var restaurants = this.restaurants;
        // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        //
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   cb(results);
        // }, 3000 * Math.random());
        if(queryString==''){
          cb([]);
          return;
        }

        api.accessOutApi({
          name:queryString
        })
          .then(rs => {

            if (rs.status == 200) {
              // console.log(rs.data.items)
              rs.data.items.forEach(item=>{
                var value = item.name;
                item.value = item.name;
                item.nameStr = value.replace(queryString, `<span style='color: #0a7afc;'>${queryString}</span>`)

              })
              console.log(rs.data.items)

              cb(rs.data.items);
            }else {

            }})
      },

      handleSelect(data,item2) {
        this.accessOutApi1(data.name,item2)

      },
      accessOutApi1(queryString,item2){

        api.accessOutApi1({
          name:queryString
        })
          .then(rs => {

            if (rs.status == 200) {
              // console.log(rs.data.items)
              var data=rs.data;

              for(var i=0;i<item2.colList.length;i++){

                if(item2.colList[i].colId=='col_0002'){
                  //统一社会信用证代码
                  item2.colList[i].colValue=data.credit_no?data.credit_no:'';

                }else if(item2.colList[i].colId=='col_0003'){
                  //*法人代表
                  item2.colList[i].colValue=data.oper_name?data.oper_name:'';
                }else if(item2.colList[i].colId=='col_0004'){
                  //*联系电话
                  item2.colList[i].colValue=data.contact.telephone?data.contact.telephone:'';
                }else if(item2.colList[i].colId=='col_0007'){
                  //*通讯地址
                  item2.colList[i].colValue=data.contact.address?data.contact.address:'';
                }

              }

            }else {

            }})
      }
    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>

  .mycontainer{
    background: #fff;
    width: 100%;
    min-height: calc(100vh - 70px);
    overflow-x: hidden;
    .tabnameclass{
      border-bottom: 1px solid #e6eaf0;
      font-size: 18px;
      color: #2a3138;
      padding: 20px;
    }
    .leftcontent{
      position: relative;
      margin: 20px;
      border: 1px solid #e6eaf0;
      width: 220px;
      border-radius: 4px;
      /*height: calc(100vh - 70px);*/
      min-height: calc(100vh - 70px);
      overflow: scroll;

      .toptitle{
        margin-right: 15px;
        line-height: 53px;
        cursor: pointer;
        width: calc(100% - 40px);
        padding:0 20px;
        font-size:14px;
        :focus {
          outline: -webkit-focus-ring-color auto 0;
        }
        /deep/ .el-tabs__item{
          :focus {
            outline: -webkit-focus-ring-color auto 0;
          }
        }
      }
      .toptitleactive{
        background-image: linear-gradient(90deg,
        #edf8ff 0%,
        rgba(246, 252, 255, 0.18) 90%,
        rgba(255, 255, 255, 0.09) 99%,
        rgba(255, 255, 255, 0.09) 100%),
        linear-gradient(
          #fff,
          #fff);
        background-blend-mode: normal,
        normal;
        color: #0a7afc;
      }
      i{
        position: absolute;
        right: 5px;
        top: 17px;
        color: #15d2be;
        font-size: 16px;
      }
    }
    .topcontent{
      position: relative;
      /*height: 57px;*/
      margin: 0 20px;
      width: calc(100% - 40px);
      align-items: center;
      .toptitle{
        margin-right: 15px;
        line-height: 53px;
        cursor: pointer;
        width: 100%;
        text-align: center;
        :focus {
          outline: -webkit-focus-ring-color auto 0;
        }
       /deep/ .el-tabs__item{
          :focus {
            outline: -webkit-focus-ring-color auto 0;
          }
        }
      }
      .toptitleactive{
        border-bottom: 4px solid #0a7afc;
        color: #0a7afc;
        margin-bottom: -3px;
        font-weight: bold;
      }
    }
    .tabcontentclass{
      min-height: calc(100vh - 70px);
      overflow: scroll;
      border: 1px solid #e6eaf0;
      margin: 20px 20px 20px 0;
      width: calc(100% - 260px);
      .tabcontent-itemclass{
        padding-bottom: 20px;

        position: relative;
        /*添加项目*/
        .addproject{
          position: absolute;
          z-index: 999;
          right: 360px;
          top: 0px;
          color: #0a7afc;
          font-size: 16px;
          cursor: pointer;
        }
        .resetproject{
          position: absolute;
          z-index: 999;
          right: 270px;
          top: 0px;
          color: #0a7afc;
          font-size: 16px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .deleteproject{
          position: absolute;
          z-index: 999;
          right: 190px;
          top: 0px;
          color: #0a7afc;
          font-size: 16px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        /*类型*/
        .typeclass{
          margin-top: 20px;
          font-size: 16px;
          line-height: 31px;
          color: #2a3138;
          padding-left: 20px;
          position: relative;
          margin-left: 20px;
          font-weight: bold;
          &::before{
            position: absolute;
            content: '';
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background: #0a7afc;
          }
        }

        /*类型下的组件*/
        .tabcontent-contentclass{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          padding: 0 20px;


        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/collection/dataCollection.vue